import { mixpanelTrack } from 'utils/app';
import { sourceOf } from 'utils/dataSources';
import { useEffect } from 'react';

/**
 * The three entity-view events. These take the data source rather than a mode
 * string: `mode` is the descriptor's `analyticsMode`, which is not its `label` —
 * Google reports 'Search' and pop-index 'Overview'.
 *
 * Each event is gated on `mode` as well as its own fields. An unresolved source
 * would otherwise send `mode: undefined`, which silently re-buckets a dashboard
 * rather than failing.
 */

const modeOf = (source) => sourceOf(source)?.analyticsMode;

/** cat5 pages: fires `Cat5`. */
export function useTrackCategoryView(
    source,
    { id, categoryName, countryName },
) {
    const mode = modeOf(source);
    useEffect(() => {
        if (categoryName && countryName && mode)
            mixpanelTrack('Cat5', { id, categoryName, countryName, mode });
    }, [categoryName, countryName, mode]);
}

/** cat2-4 pages: the event name is the entity's own depth, not a literal. */
export function useTrackDepthView(source, { depth, name, country }) {
    const mode = modeOf(source);
    useEffect(() => {
        if (name && depth && country && mode)
            mixpanelTrack(depth, { name, countryName: country.name, mode });
    }, [name, depth, country, mode]);
}

/** brand pages: fires `Brand`. */
export function useTrackBrandView(source, { brandId, brandName, countryName }) {
    const mode = modeOf(source);
    useEffect(() => {
        if (brandName && countryName && mode)
            mixpanelTrack('Brand', { brandId, brandName, countryName, mode });
    }, [brandName, countryName, mode]);
}
